import React from 'react';
import Etiqueta from './EtiquetaCustom';
import './styles.css'

const ImprimirEtiquetas = ({ refAImprimir, quantity, title, price, etiquetas = [] }) => {
  const buildEtiquetas = () => {
    var etiquetas = []
    for (let index = 0; index < quantity; index++) {
      etiquetas.push(<Etiqueta
        key={index}
        producto={title}
        precio={price}
      />)
    }
    return etiquetas;
  }

  return (
    <div ref={refAImprimir} className="imprimir">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
          {etiquetas.length === 0 ? buildEtiquetas() : etiquetas}
        </div>
    </div>
  );
};

export default ImprimirEtiquetas;
